import 'swiper/swiper-bundle.css'
import '../styl/main.styl'

import './modules/navigation'
import './modules/swiper'
import './modules/animated-entry'
import './modules/counting-entry'
import './modules/newsletter-signup'
import './modules/logo-animation'
import './modules/feature-animations'
import './modules/accellerator-animation'
import './modules/maps'
import './modules/press'
import './modules/cookie-notice'
import './modules/videoplayer'
import './modules/banner'

import AnimatedShape from './modules/animated-shape'

if(navigator.userAgent.match(/Trident\/7\./)) {
  document.body.addEventListener("mousewheel", function() {
    event.preventDefault()
    let wd = event.wheelDelta
    let csp = window.pageYOffset
    window.scrollTo(0, csp - wd)
  })
}

let animatedShapes = document.querySelectorAll('.js-animated-shape')
for (let i=0; i < animatedShapes.length; i++) {
  let shape = animatedShapes[i]
  new AnimatedShape(shape)
}
